import { Heading } from '@klp/design/Heading';
import React from 'react';

export const KostnadsKalkyleTitle: React.FC = () => {
    return (
        <Heading
            klpHeadingLevel="TWO"
            translation="prosjekt.kostnadskalkyle.title.general"
            marginBottom="compact"
        />
    );
};
